import { withRouter } from 'next/router';
import React from 'react';
import dynamic from 'next/dynamic'
import MuhammadAliScholarships from '../components/static/scholarshipPage';
const Layout = dynamic(() => import('../hoc/staticLayout'), { loading: () => <></>, ssr: true });


const Scholarship = (props) => {
    const meta = {
		title: "Scholarship | Bayan",
		description: "The Bayan Muhammad Ali Spiritual Leadership Full Tuition Scholarship is an honor bestowed upon a deserving and highly qualified full-time entering graduate student enrolled in Bayan’s 48-unit Master of Arts (concentrations available in Islamic Studies, Islamic Leadership, Islamic Education, and Islamic Theology), or in the 75-unit Master of Divinity in Islamic Chaplaincy program.",
		route: "arabic",
	}
    return (
        <Layout theme={props.theme} meta={meta}>
            <MuhammadAliScholarships/>
        </Layout>
     );
}

export default withRouter(Scholarship);